module.exports = __webpack_public_path__ + "img/HomeImage.f99745f8.png";